import ErrorPage from "../../components/globals/ErrorPage";

export const NotFound = () => {
  return (
    <ErrorPage title="403">
      Desculpe, você não está autorizado a acessar esta página.
    </ErrorPage>
  )
};
